module.exports = __webpack_public_path__ + "img/meme-themed-logo.d8514925.svg";